/**
 * @generated SignedSource<<b5bce82da2fe7869cb681fccaa43bcaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type QueriesPaginatedCoordinatesQuery$variables = {
  after?: string | null;
  documentIds?: ReadonlyArray<number> | null;
  first?: number | null;
};
export type QueriesPaginatedCoordinatesQuery$data = {
  readonly paginatedCoordinates: {
    readonly items: ReadonlyArray<{
      readonly _id: any;
      readonly dateTime: string;
      readonly documentId: number;
      readonly latitude: number;
      readonly longitude: number;
    }> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
};
export type QueriesPaginatedCoordinatesQuery = {
  response: QueriesPaginatedCoordinatesQuery$data;
  variables: QueriesPaginatedCoordinatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "documentIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "documentIds",
        "variableName": "documentIds"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "concreteType": "ModelCoordinateConnection",
    "kind": "LinkedField",
    "name": "paginatedCoordinates",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Coordinate",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "latitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longitude",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endCursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNextPage",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QueriesPaginatedCoordinatesQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "QueriesPaginatedCoordinatesQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "1dc5db3a05df607acdcb3487753fa751",
    "id": null,
    "metadata": {},
    "name": "QueriesPaginatedCoordinatesQuery",
    "operationKind": "query",
    "text": "query QueriesPaginatedCoordinatesQuery(\n  $documentIds: [Int!]\n  $first: Int\n  $after: String\n) {\n  paginatedCoordinates(documentIds: $documentIds, first: $first, after: $after) {\n    items {\n      _id\n      documentId\n      dateTime\n      latitude\n      longitude\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "467d51eb304f983b5a964c464a3b0659";

export default node;
